<template>
    <div class="wrapper-popup">
        <div class="card-popup">
            <a class="button-close" @click="$emit('close', true)">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 384 512">
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
            </a>
            <div class="card-body">
                <h3>Input Phone Number</h3>
                <p>Silahkan input nomor telepon anda terlebih dahulu</p>
                <div class="button">
                    <a @click="checkVerified()" class="btn btn-red mr-auto">Input Sekarang</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['event'],
    methods: {
        trackerUpdateInformation(event) {
            let data = {
                'event': 'updateInformation',
                'eventDetail.category': 'Update Information HCID',
                'eventDetail.action': 'Notif Input Phone Number - Input Sekarang',
                'eventName': event.name, //Event Name
                'id': event.id, //Event ID
                'eventType': event.type,//Event Type
                'startDate': event.start_date, //Event Start Date
                'endDate': event.end_date, //Event End Date
                'publishedDate': event.created_at,//Event Created Date
                'province': event.province,//Event Province
            }
            console.log(data, 'Notif Input Phone Number - Input Sekarang');
            dataLayer.push(data);
        },
        async checkVerified() {
            console.log('res');
            this.trackerUpdateInformation(this.event);
            window.location.href = `${this.event.detail_url_web}/verification-phone`
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper-popup {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(21, 21, 21, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
        width: 90%;
        max-width: 558px;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            text-align: center;
            color: rgba(40, 40, 40, 1);
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
                font-size: 15px;
                width: 100%;
                max-width: 100%;
                margin-bottom: 55px;
                line-height: 1.4;
                word-wrap: break-word;
            }

            .button {
                padding-top: 15px;

                .btn {
                    width: 100%;
                    max-width: 100%;
                    font-weight: 700;
                    font-size: 14px;
                    padding: 20px;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                        background-color: #333 !important;
                        color: #fff;
                    }
                }
            }

            .red-button {
                background-color: #E61B33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 768px) {
    .wrapper-popup {
        .card-popup {
            padding: 15px;
            max-width: 90%;
        }
    }
}
</style>
